// ModelToText.js
import { useEffect } from "react"
import { SwmmConvert } from "@fileops/swmm-node"

/**
 * ModelToText is a function that translates an EPA-SWMM JSON object into 
 * a parseable EPA-SWMM .inp file string.
 * 
 * @param {JSON} model EPA-SWMM model 
 * @param {function} setSwmmTxt state function for setting the string contents of an EPA-SWMM .inp file.
 */
function ModelToText({model, setSwmmTxt}) {
  useEffect(()=>{
    let swmmTxt = SwmmConvert.dataToInpString(model)
    setSwmmTxt(swmmTxt)
  }, [model])
}

export {ModelToText}